import React, { PureComponent } from 'react';

import PropTypes from 'prop-types';

import './ContentSelectedItem.scss';

export default class ContentSelectedItem extends PureComponent {
  static propTypes = {
    item: PropTypes.object,
    onClose: PropTypes.func,
    additionalLabel: PropTypes.string
  };

  render() {
    const { item, onClose, additionalLabel } = this.props;

    return (
      <div className="show__data__selected">
        <div className="show__data__selected__text show__data__selected__label">
          {item.name}
        </div>
        <span className="show__data__selected__actions">
          {additionalLabel && (
            <div className="show__data__selected__text show__data__selected__additional__label">
              {additionalLabel}
            </div>
          )}
          <div
            className="show__data__selected__close"
            onClick={() => onClose(item)}
          >
            <i className="icon icon-close" />
          </div>
        </span>
      </div>
    );
  }
}
